import { BrandListItem } from '../../../integrated-client/models'

export interface IBrandEditorData {
  brandData?: BrandListItem
  validation?: any
}
export class BrandEditorData implements IBrandEditorData {

  brandData?:  BrandListItem
  validation?: any
}